(() => {
  if (window.__productFavoritesLoaded) return;
  window.__productFavoritesLoaded = true;

  const storageKey = window.RAGStudioFavorites?.storageKey || 'ragstudio_favorites';

  const readFavorites = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  };

  const writeFavorites = (handles) => {
    const favorites = Array.from(new Set(handles.filter(Boolean)));
    localStorage.setItem(storageKey, JSON.stringify(favorites));
    document.dispatchEvent(new CustomEvent('ragstudio:favorites:change', { detail: { favorites } }));
    updateHeaderCount(favorites);
    return favorites;
  };

  const updateHeaderCount = (favorites = readFavorites()) => {
    const count = favorites.length;
    document.querySelectorAll('[data-favorites-count]').forEach((badge) => {
      const value = badge.querySelector('[data-favorites-count-value]');
      const label = badge.querySelector('[data-favorites-count-label]');
      if (value) value.textContent = count;
      if (label) label.textContent = count === 1 ? '1 produto favorito' : `${count} produtos favoritos`;
      badge.classList.toggle('hidden', count === 0);
    });

    document.querySelectorAll('[data-favorites-header-link]').forEach((link) => {
      link.setAttribute(
        'aria-label',
        count === 1 ? 'Favoritos, 1 produto guardado' : `Favoritos, ${count} produtos guardados`
      );
    });
  };

  const updateButtons = () => {
    const favorites = readFavorites();
    document.querySelectorAll('[data-product-favorite-toggle]').forEach((button) => {
      const isActive = favorites.includes(button.dataset.productHandle);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    updateHeaderCount(favorites);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-favorite-toggle]');
    if (!button) return;

    const handle = button.dataset.productHandle;
    if (!handle) return;

    const favorites = readFavorites();
    const nextFavorites = favorites.includes(handle)
      ? favorites.filter((favoriteHandle) => favoriteHandle !== handle)
      : [...favorites, handle];

    writeFavorites(nextFavorites);
    updateButtons();
  });

  document.addEventListener('shopify:section:load', updateButtons);
  document.addEventListener('ragstudio:favorites:change', updateButtons);
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) updateButtons();
  });
  updateButtons();
})();
